import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function ChangePassword() {
  const { user, checkAuth } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.new_password !== form.confirm) return setError("As senhas não coincidem");
    try {
      await api.post("/auth/change-password", { current_password: form.current_password, new_password: form.new_password });
      toast.success("Senha alterada!");
      await checkAuth();
      navigate("/admin");
    } catch (e) { setError(formatApiErrorDetail(e.response?.data?.detail)); }
  };

  const field = (key, label, testid) => (
    <div><Label>{label}</Label><Input required type="password" minLength={key === "current_password" ? 1 : 8} value={form[key]} onChange={(e) => setForm({ ...form, [key]: e.target.value })} data-testid={testid} /></div>
  );

  return (
    <div className="max-w-md" data-testid="change-password-page">
      <h1 className="text-2xl font-serif text-[#9B6179] mb-2">Alterar senha</h1>
      {user?.must_change_password && <p className="text-sm text-[#6F3F55] mb-6" data-testid="must-change-password-notice">Bem-vinda! Defina sua senha pessoal para continuar.</p>}
      <form onSubmit={submit} className="space-y-3 bg-white p-6 rounded-[2px] border border-[#9B6179]/5">
        {field("current_password", user?.must_change_password ? "Senha provisória" : "Senha atual", "change-password-current")}
        {field("new_password", "Nova senha (mín. 8 caracteres)", "change-password-new")}
        {field("confirm", "Confirmar nova senha", "change-password-confirm")}
        {error && <p className="text-sm text-red-700" data-testid="change-password-error">{error}</p>}
        <Button type="submit" className="w-full bg-[#090708] text-[#E8C47A] rounded-[2px] hover:bg-[#6F3F55] transition-colors" data-testid="change-password-submit">Salvar nova senha</Button>
      </form>
    </div>
  );
}
